export const tabs = {
  requestNew: {
    value: 'request-new',
    label: 'Kèo tìm xe'
  },

  reConfirm: {
    value: 'request-confirm',
    label: 'Chờ xác nhận'
  }
};
